export class SemToken{
    accessToken:string;
    expires:Date;
    created:Date;
}